import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        name: '',
        component: () => import('@/views/reset/login.vue'),
        meta: {
            title: '登录',
            showTabBar: false,
        },
    },
    {
        path: '/BMI_login',
        name: 'BMI_login',
        component: () => import('@/views/reset/BMI_login.vue'),
        meta: {
            title: '登录',
            showTabBar: false,
        },
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home.vue'),
        meta: {
            title: '首页',
            showTabBar: false,
        },
    },
    {
        path: '/AboutView',
        name: 'AboutView',
        component: () => import('@/views/AboutView'),
        meta: {
            title: '测评须知',
            showTabBar: false,
        },
    },
    {
        path: '/report_center',
        name: 'report_center',
        component: () => import('@/views/report_center'),
        meta: {
            title: '报告中心',
            showTabBar: true,
        },
    },
    {
        path: '/My_report',
        name: 'My_report',
        component: () => import('@/views/My_report.vue'),
        meta: {
            title: '我的报告',
            showTabBar: true,
        },
    },
    {
        path: '/report_center_item',
        name: 'report_center_item',
        component: () => import('@/views/report_center_item'),
        meta: {
            title: '报告中心',
            showTabBar: false,
        },
    },

    // {
    //     path: '/register',
    //     name: 'register',
    //     component: () => import('@/views/register.vue'),
    //     meta: {
    //         title: '注册',
    //     },
    // },
    {
        path: '/answer',
        name: 'answer',
        component: () => import('@/views/answer.vue'),
        meta: {
            title: '作答',
            showTabBar: false,
        },
    },
    {
        path: '/report_details',
        name: 'report_details',
        component: () => import('@/views/report_details.vue'),
        meta: {
            title: '报告列表',
            showTabBar: false,
        },
    },
    {
        path: '/Evaluation_list',
        name: 'Evaluation_list',
        component: () => import('@/views/evaluation.vue'),
        meta: {
            title: '测评列表',
            showTabBar: true,
        },
    },
    {
        path: '/report_detail_desc',
        name: 'report_detail_desc',
        component: () => import('@/views/report_detail_desc.vue'),
        meta: {
            title: '报告详情',
            showTabBar: false,
        },
    },
    {
        path: '/my_center',
        name: 'my_center',
        component: () => import('@/views/my.vue'),
        meta: {
            title: '个人中心',
            showTabBar: false,
        },
    },
    {
        path: '/disPass',
        name: 'disPass',
        component: () => import('@/views/myInner/disPass.vue'),
        meta: {
            title: '未完成测评',
            showTabBar: false,
        },
    },
    {
        path: '/bind',
        name: 'bind',
        component: () => import('@/views/myInner/bind.vue'),
        meta: {
            title: '已绑定账号',
            showTabBar: false,
        },
    },
    {
        path: '/my_evaluation',
        name: 'my_evaluation',
        component: () => import('@/views/my_evaluation.vue'),
        meta: {
            title: '我的测评',
            showTabBar: true,
        },
    },
    {
        path: '/waiting',
        name: 'waiting',
        component: () => import('@/views/reset/waiting.vue'),
        meta: {
            title: '认证中',
            showTabBar: false,
        },
    },
    {
        path: '/answer_online',
        name: 'answer_online',
        component: () => import('@/views/answer_online.vue'),
        meta: { title: '作答', showTabBar: false },
    },
    {
        path: '/BMIDetail',
        name: 'BMIDetail',
        component: () => import('@/views/BMIDetail.vue'),
        meta: { title: '单词指标', showTabBar: false },
    },
    {
        path: '/BMIDetail_new',
        name: 'BMIDetail_new',
        component: () => import('@/views/BMIDetail_new.vue'),
        meta: { title: '单词指标', showTabBar: false },
    },
    {
        path: '/BMI_result',
        name: 'BMI_result',
        component: () => import('@/views/BMI_result_show.vue'),
        meta: { title: 'BMI结论', showTabBar: false },
    },
]

const router = new VueRouter({
    routes,
})

router.beforeEach((to, form, next) => {
    if (sessionStorage.getItem('query')) {
        const query = JSON.parse(sessionStorage.getItem('query'))
        if (query && query.isBMI) {
            document.title = '身高体重预测系统'
        } else {
            document.title = '心理健康测评'
        }
    } else {
        document.title = '心理健康测评'
    }

    let openid = sessionStorage.getItem('token')
    next()
    // if (!openid && to.path === '/AboutView') {
    //     next()
    // } else {
    //     if (!openid && to.path !== '/') {
    //         router.replace({ path: '/' })
    //     } else if (openid && to.path === '/') {
    //         router.replace('/Evaluation_list')
    //         next(false)
    //     } else {
    //         next()
    //     }
    // }
})

export default router
